export default {
  tabs: {
    gift_cards: 'Carte regalo',
    settings: 'Impostazioni',
  },
  gift_cards: {
    title: 'Carte regalo',
    subtitle: 'Gestisci tutte le carte regalo del tuo ristorante',
    buttons: {
      create: 'Crea carta regalo',
      redeem: 'Riscatta carta regalo',
      check_balance: 'Controlla saldo',
    },
    search: {
      placeholder: 'Inserisci testo di ricerca',
    },
    columns: {
      code: 'Codice',
      status: 'Stato',
      balance: 'Saldo',
      value: 'Valore',
      email: 'Acquirente',
      source: 'Fonte',
      created_at: 'Creata',
    },
    statuses: {
      active: 'Attiva',
      partially_redeemed: 'Parzialmente riscattata',
      redeemed: 'Riscattata',
    },
  },
  settings: {
    gift_cards_availability: {
      title: 'Impostazioni carte regalo',
      subtitle: 'Configura le opzioni delle carte regalo per il tuo ristorante',
      availability: {
        title: 'Abilita le carte regalo',
        subtitle: 'Consenti ai clienti di acquistare e riscattare carte regalo',
        buttons: {
          enable: 'Abilita',
          disable: 'Disabilita',
        },
      },
    },
    redemption_options: {
      title: 'Opzioni di riscatto',
      subtitle: 'Scegli dove i clienti possono riscattare le carte regalo',
      redemption_mode: {
        title: 'Modalità di riscatto',
        subtitle: 'Influenza il testo mostrato sulla pagina della carta regalo',
        buttons: {
          online: 'Solo online',
          online_and_store: 'Online e in negozio',
        },
      },
    },
  },
  summary: {
    total_value: 'Valore totale',
    total_active: 'Totale attive',
    redeemed_this_month: 'Riscattate questo mese',
  },
};
